export const environment = {
  production: true,
  name : "production",
  APP_PORT: "https://api.relead.tn/api",
  CALENDAR_ORIGIN: "https://calendar.relead.tn",
  CDN_RELEAD: "https://cdn.relead.tn/",
  APP_PORT_IBERIS: "https://api.iberis.io/",
  topFranchisedLimit: 5,
  PAYMENT: {
    RETURN_URL:
      "https://app.relead.tn/dashboard/advertiser/advertising-campaigns/payment-success",
    WEBHOOK_URL:
      "https://app.relead.tn/dashboard/advertiser/advertising-campaigns/payment-success",
    CANCEL_URL:
      "https://app.relead.tn/dashboard/advertiser/advertising-campaigns/payment-cancel",
    APP_PAYMEE: {
      URL: "https://sandbox.paymee.tn",
      TOKEN: "Token 1359866bca1be8da0f05d5a7c816e8ebe8bfd2ab",
    },
    APP_KONNECT: {
      URL: "https://api.konnect.network",
      WALLET: "65bd4cdf43e3d4fae6e5ef82",
      TOKEN: "65bd4cdf43e3d4fae6e5ef7e:QxjqdpkhlrFGPMlaw2scyio",
    },
  },
  links: {
    requestFeat : "https://forms.clickup.com/37327298/f/13k4e2-29315/1TKHAWKAR4I3P6CQP5",
    bookMeetingLP : "https://calendly.com/relead-support/30min?month=2024-02",
    //bookMeetingAdvertiser : "https://calendly.com/relead-sales/30min?month=2024-02",
    bookMeetingAdvertiser :"https://calendly.com/relead-sales/demo-relead-2-0",
    contactRelead : "https://relead.tn/contact",
    blogs: "https://relead.tn/blog/",
    termsOfUse: "https://relead.tn/conditions-generales-dutilisation/"
  },
  RECAPTCHA_PUBLIC_KEY: "6LfDMmQqAAAAAF5-oyZdpqel9KswOox8o51t0pIi",
  IBERIS:{
    IBERIS_COMPANY_ID : "qXDZ",
    PAYMENT_METHOD: "RWKWZ",
    BANK_ID : "JwNv",
    TAX_HASHED_ID :"mqDP",
    TIMBRE_FISCAL_HASHED_ID: "Ovyo",
    TOKEN : "$2y$10$RkgpSbSP7Yl6kAaruepMRe3XYnpkMPkhJFC4fJ.3Rgrw2V7/RrcKC",
    DEADLINE_ID : "YAXzG",
    PRICE_ID : "nYAG",
    COUNTRY_ID: "QNMV"
  },
  googleMapsApiKey: 'AIzaSyBJpOwI5ipx0rbyqA9HKdCdNnrmVRCwdKI',
  clarityId: "uws73tdyku",

  MIN_ESTIMATED_CLICKS_WEBSITE_TRAFFIC : 0.11, //11%
  MAX_ESTIMATED_CLICKS_WEBSITE_TRAFFIC : 0.2, //20%

  MIN_ESTIMATED_CLICKS_LEAD_GEN : 0.1, //10%
  MAX_ESTIMATED_CLICKS_LEAD_GEN : 0.15, //15%

  MIN_ESTIMATED_LEADS : 0.03, //3%
  MAX_ESTIMATED_LEADS : 0.05, //5%
      
  CLICKUP_CRM_LIST_ID : "901519196719",
  CLICKUP_ADS_LIST_ID : "210288574", 
  CLICKUP_ADS_ASSIGNEES: 60256026, //Eya
  CLICKUP_ADS_STATUS: "scheduled",
  CLICKUP_CRM_STATUS: "lead identified",
  CLICKUP_CRM_ASSIGNEES: 49436116, //Hadhami,
  CLICKUP_CRM_TAG:"app.relead.tn",

  CLICKUP_ADS_REDIRECTION_LINK:"ba3b7b1e-5609-4030-8b51-f9091e402905",
  CLICKUP_ADS_START_DATE:"7a3791c5-86ef-4125-914c-67158e973a92",
  CLICKUP_ADS_END_DATE:"15855b9d-b0ef-4b55-986e-c393de1af583",
  CLICKUP_ADS_TARGET_OBJECTIVE:"60d82b81-15d8-407b-b413-a02d00e64063",
  CLICKUP_ADS_OBJECTIVE:"89e3ae6e-ef15-49bf-bb21-cea9229ab060",

  CLICKUP_CRM_PRIMARY_CONTACT:"f6774f69-3b3b-4c18-b3b6-6ceb7bbc6ec1",
  CLICKUP_CRM_EMAIL:"1f7bc39b-a2ae-4059-9170-27431c94307b",
  CLICKUP_CRM_WEBSITE:"f65acd79-042c-4d97-adc5-425fb8511c17",
  CLICKUP_CRM_PHONE_NUMBER:"1a896d20-aa8c-4270-b572-f4abb89fbb0f",
  CLICKUP_CRM_SOURCE:"95b76335-4f5a-4b5e-9a9f-f43976125e6e",
  CLICKUP_CRM_INBOUND:"b7b6dff6-ed4f-4be0-a973-bac14b90c807",

  POSTHOG_API_KEY: "phc_1iVhOmUDK38uacsydnYzogT7tyaf148riDJbAhGOTah",
  POSTHOG_API_HOST: "https://eu.i.posthog.com"
};
